module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"engine":"Engine","template":"Template","name":"Name","noPrompt":"No prompt"}}')
  delete Component.options._Ctor
}
